import React from 'react';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { fetchRequestLocations, fetchRequestWorkspaces, toggleRequestWorkspaceSelected } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';
import requestWorkspaceLocation from '../helper';

const RequestWorkspacesContainer = ({
  category,
  children,
  code,
  fetchLocations,
  readStatus,
}) => {
  fetch.useFetchByCode(fetchLocations, category, code, readStatus, fetchConfig([category, code, readStatus]));
  return (<>{children}</>);
};

export const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { workspaces } = request.steps;
  const {
    location,
    locations,
    locationsReadStatus,
    locationsReadErrors,
  } = requestWorkspaceLocation(request);

  return ({
    location,
    locations,
    locationsReadStatus,
    readErrors: workspaces.readErrors.concat(locationsReadErrors),
    readStatus: workspaces.readStatus,
    workspaces: workspaces.results,
  });
};

export const mapDispatchToProps = {
  fetchLocations: fetchRequestLocations,
  fetchWorkspaces: fetchRequestWorkspaces,
  onCheckBoxClick: toggleRequestWorkspaceSelected,
};

export default RequestWorkspacesContainer;
